import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';
export const SOURCING_EVENTS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('SOURCING_EVENTS');
export const SOURCING_EVENTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	SOURCING_EVENTS_CRUD_ACTION_CONSTANTS
);
